import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { FranchiseValues } from 'src/models/Franchise.model';
import FranchiseForm from '../Layouts/FranchiseForm';
import { useAddFranchiseMutation } from 'src/services/FranchiseService';
import { showToast } from 'src/utils/showToaster';

type Props = {
  onClose: () => void;
};

const AddFranchiseWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: FranchiseValues = {
    name: '',
    mobile: '',
    location: "",
  };


  const [addFranchise] = useAddFranchiseMutation()

  // Handle Submit
  const handleSubmit = (
    values: FranchiseValues,
    { setSubmitting, resetForm }: FormikHelpers<FranchiseValues>
  ) => {
    addFranchise(values).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm()
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };



  // Validation Schema
  const validationSchema = object().shape({
    name: string().required('Please enter name'),
    mobile: string()
    .required("Please enter mobile number")
    .matches(/^[0-9]{10}$/, {
      message: "Mobile number should contain exactly 10 digits."
    }),
    location: string().required('Please enter location'),
  });


  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <FranchiseForm formikProps={formikProps} onClose={onClose} formType="ADD" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddFranchiseWrapper;